<template>
  <div class="control-input">
    <input
      type="number"
      :placeholder="ikey"
      :readonly="readonly"
      :value="value"
      @input="change($event)"
      @dblclick.stop=""
      @pointerdown.stop=""
      @pointermove.stop=""
    />
  </div>
</template>

<script>
  export default {
    name: 'VueNumControl',
    props: ['readonly', 'emitter', 'ikey', 'getData', 'putData'],
    data: () => {
      return {
        value: 0,
      }
    },
    methods: {
      change(e){
        this.value = +e.target.value;
        this.update();
      },
      update() {
        if (this.ikey)
          this.putData(this.ikey, this.value)
        this.emitter.trigger('process');
      }
    },
    mounted() {
      this.value = this.getData(this.ikey);
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  /*.node .control-input {
    padding: 6px 18px;
  }*/
</style>
